import React, { useState, useEffect } from "react";
import styled from "styled-components";

// --- CSS 스타일 정의 (Styled-Components) ---
const Overlay = styled.div`
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* 반투명 검은 배경 */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const DialogBox = styled.div`
    background-color: white;
    padding: 2rem;
    border-radius: 10px;
    width: 400px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    color: black;
`;

const Input = styled.input`
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
`;

const Button = styled.button`
    padding: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    color: white;
    /* props.bgColor -> props.$bgColor 로 변경 */
    background-color: ${(props) => props.$bgColor || "#9264bf"};
    flex: 1;
`;

// --- 컴포넌트 로직 ---
function LoginDialog({ isOpen, onClose, onLogin }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    // 모달 열릴 때 초기화
    useEffect(() => {
        if (!isOpen) {
            setEmail("");
            setPassword("");
            setError("");
        }
    }, [isOpen]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // 유효성 검사
        if (!email.includes("@")) {
            setError("이메일 형식이 올바르지 않습니다.");
            return;
        }
        if (password.length < 6) {
            setError("비밀번호는 6자리 이상이어야 합니다.");
            return;
        }
        onLogin(email);
        onClose();
    };

    if (!isOpen) return null; // 열리지 않았으면 아무것도 안 그림

    return (
        <Overlay>
            <DialogBox>
                <h2 style={{ textAlign: "center", color: "#9264bf" }}>로그인</h2>
                <form onSubmit={handleSubmit}>
                    <label>이메일</label>
                    <Input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="example@email.com"
                    />

                    <label>비밀번호</label>
                    <Input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="6자리 이상"
                    />

                    {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}

                    <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                        <Button type="submit">로그인</Button>
                        <Button type="button" onClick={onClose} $bgColor="#888">닫기</Button>
                    </div>
                </form>
            </DialogBox>
        </Overlay>
    );
}

export default LoginDialog;